<template>

  <b-row>
    <b-col cols="12">
      <!-- PERMISSION TABLE -->
      <b-card no-body class="border">

        <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
        </div>

        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <feather-icon icon="KeyIcon" size="18"/>
            <span class="align-middle ml-50">{{ $t('Roles')}}</span>
          </b-card-title>
        </b-card-header>


        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->

            <b-col cols="12" md="6">
      <!-- Action Buttons -->
      <b-button
          type="submit"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="submit"
      >
       {{ $t('Save Changes')}}
      </b-button>
    </b-col>
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('entries') }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')"/>
              </div>
            </b-col>
          </b-row>
       
        </div>
        <b-table striped responsive class="mb-0"
                 :items="authRoles" :fields="fields">

          <template #head(list)="data">
            <b-form-checkbox @change="checkAll(data, $event)" />
          </template>

          <template #cell(name)="data">
            {{ data.item.name }}
          </template>

          <template #cell()="data">
            <b-form-checkbox :state="userRoles.includes(data.item.name) ? true : null" :checked="requestRoles.includes(data.item.name)" @change="change(data, $event)" />
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col cols="12" sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                {{ $t('Showing') }} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{ $t('of')}} {{ dataMeta.of }} {{$t('entries-users')}}
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalTable"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-col>


    


  </b-row>
</template>

<script>
import {
BFormFile,
BButton,
BForm,
BFormGroup,
BFormInput,
BRow,
BCol,
BAlert,
BCard,
BCardText,
BMedia,    BPagination,
BMediaAside,
BMediaBody,
BLink,BBadge,
BImg,
BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import permissionsStoreModule from '@/views/modules/user/users-edit/permissions/permissionsStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import UsersFilter from '@/views/modules/user/users-edit/permissions/UsersFilter'
import { OrbitSpinner } from 'epic-spinners'
import filters from "@/views/modules/Utils/filters";

export default {
components: {
  BButton, BForm, BImg, BFormFile,
  BFormGroup, BFormInput, BRow,
  BCol, BAlert, BCard, BCardText,BBadge,
  BMedia, BMediaAside, BMediaBody, vSelect,BPagination,
  BLink,BTable,BFormCheckbox,  BCardTitle, BCardHeader, UsersFilter,
  OrbitSpinner
},
directives: {
  Ripple,
},
props: {
  user: {
    type: Number,
    required: true
  },
},

setup(props, { root, emit }) {

  const USERS_PERMISSION_APP_STORE_MODULE_NAME = 'app-permission'

  if (!store.hasModule(USERS_PERMISSION_APP_STORE_MODULE_NAME))
    store.registerModule(USERS_PERMISSION_APP_STORE_MODULE_NAME,
        permissionsStoreModule)


  const authRoles = ref([])
  const userRoles = ref([])


  const {perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

  const filter = ref({})

  watch([currentPage, perPage, searchQuery ], () => {
    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }

    fetchAuthRoles()
  })



  const requestPending = ref(false)

  const fetchAuthRoles = () => {
    requestPending.value = true

     setTimeout(()=>{
      const roles=store.state.auth.userData.roles;
    authRoles.value = roles.map((i)=>({'id':i,'name':i}))
      requestPending.value = false

     },1000)
   

  //   store.dispatch('app-permission/userGetRoles', {
  //     //length: perPage.value,
  //   //  page: currentPage.value,
  //     user: store.state.auth.userData.id,
  //    // type: 'role',
  //     ...filter.value
  //   })
  //   .then(response => {
     
  //     requestPending.value = false
  //     const { roles } = response.data
  //    // totalTable.value = total
  //     authRoles.value = roles.map((i)=>({'id':i,'name':i}))
  //   })
  //   .catch(res =>{
  //     requestPending.value = false
  //     toaster(root.$t('Error Happened'), 'danger','error')
  //   })
  }

  fetchAuthRoles()

  store.dispatch('app-permission/userGetRoles', { user: props.user})
      .then(res => {
        requestRoles.value = res.data.roles.map(a => a)
        userRoles.value = res.data.roles.map(a => a)
      }).catch(res => {})


  const  fields = ['name','list']


  const submit = () => {

    requestPending.value = true
    const roles=store.state.auth.userData.roles;
    const filterdRequest=  requestRoles.value.filter((i)=>roles.includes(i))
  

    store.dispatch('app-permission/userGiveRoles', {
      user: props.user,
      roles: filterdRequest
    }).then(res => {

      requestPending.value = false
      toaster('user roles updated successfully', 'success','success')
      changedIds.value = []
      userRoles.value = requestRoles.value.map(x => x.name)

    }).catch(reason => {
      requestPending.value = false
      toaster('Error Happened', 'danger','Error')
    })
  }

  const requestRoles = ref([])
  const changedIds = ref([])
  const current_selected=ref([])


  /**
   * check all
   * @param data
   * @param value
   */


   
  

   // user three refs 
   //1- auth items from api
   //2- requset items  = current checked + other screen checked items if unchecked get otehr items assigned to thirf ref
   //3- hold unique items
  const checkAll = (data, value) => {     
        if (value){    
      authRoles.value.map(item => {
     if(requestRoles.value.indexOf(item.name)==-1){
      requestRoles.value.push(item.name)
     }   
      })
       requestRoles.value.map((v) =>{
      
        if(current_selected.value.indexOf(v) < 0){
          current_selected.value.push(v)
        }
      })
     
    }
    else{
        authRoles.value.map(item => {        
        const index = current_selected.value.indexOf(item.name)    
    
        if (index !== -1) current_selected.value.splice(index, 1)
      })
    }
 requestRoles.value=[]
 requestRoles.value=current_selected.value;
  
    }
  



  /**
   * change one
   * @param data
   * @param value
   */
  const change = (data, value) => {
    const index = requestRoles.value.indexOf(data.item.name);
    if (value && index === -1) requestRoles.value.push(data.item.name)
    else requestRoles.value.splice(index, 1)
  }


  const toaster = (msg, variant, title) => {
    root.$root.$bvToast.toast(msg, {
      title,
      variant,
      solid: true,
    })
  }

  return {
    requestPending,

    authRoles,
    userRoles,
    perPage,
    perPageOptions,
    currentPage,
    searchQuery,
    totalTable,
    dataMeta,
    change,
    fields,
    checkAll,
    submit,
    fetchAuthRoles,
    requestRoles,
    current_selected
  }
},
}
</script>
